import { ReactElement } from 'react';

import { VisitTimeSinceLast, VisitTimeSinceLastQuery } from '@dreryk/egabinet-visit-frontend-api';
import { PatientId } from '@dreryk/egabinet-patient-published-language-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { VisitId } from '@dreryk/egabinet-visit-published-language-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { translationKeys } from '../../translations';

type TimeSinceLastVisitLoaderChildrenRenderProps = {
   readonly timeSinceLast: VisitTimeSinceLast;
};

type TimeSinceLastVisitLoaderProps = {
   readonly patientId: number;
   readonly practitionerId: number;
   readonly excludedVisitId?: number;
   readonly children: (renderProps: TimeSinceLastVisitLoaderChildrenRenderProps) => ReactElement;
};

export const TimeSinceLastVisitLoader = (props: TimeSinceLastVisitLoaderProps): ReactElement => {
   const {
      data: timeSinceLast,
      loading: timeSinceLastLoading,
      error: timeSinceLastError,
   } = useCqrsGet<VisitTimeSinceLast>(() => {
      const query = new VisitTimeSinceLastQuery();
      query.patientId = PatientId.of(props.patientId);
      query.practitionerId = PractitionerId.of(props.practitionerId);
      if (props.excludedVisitId !== undefined) {
         query.excludedVisitId = Slot.of(VisitId.of(props.excludedVisitId));
      }
      return query;
   });

   if (timeSinceLastLoading) {
      return <LoaderSpinner />;
   }

   if (timeSinceLastError) {
      return (
         <Message
            testId={'timeSinceLastVisitLoadError'}
            label={translationKeys.timeSinceLastVisit.loadError}
            type={MessageType.NEGATIVE}
            displayIndicator
            fullWidth
         />
      );
   }

   return props.children({ timeSinceLast: timeSinceLast });
};
